export default {
  translation: {
    common: {
      emailOrUsername: 'Correo o nombre de usuario',
      invalidUsernameOrPassword: 'Nombre de usuario o contraseña incorrecto',
      logInToBoards: 'Iniciar sesión',
      noInternetConnection: 'Sin conexión a internet',
      pageNotFound_title: 'Página no encontrada',
      password: 'Contraseña',
      serverConnectionFailed: 'Conexión con el servidor fallida',
      unknownError: 'Error desconocido, intenta más tarde',
    },

    action: {
      logIn: 'Iniciar sesión',
    },
  },
};
